"use strict";
/***
 * 作者个人发布：国盛证券-孟兴亚发布研报
 *  */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var datatable_1 = __importDefault(require("../../src/modules/datatable"));
var utils_1 = __importDefault(require("../../src/modules/commonutil/utils"));
var dataurl_1 = __importDefault(require("../../src/modules/datatable/dataurl"));
var dataconfig_1 = __importDefault(require("../../src/modules/datatable/dataconfig"));
window["tableconfigdatas"] = { tablecolumns: dataconfig_1["default"], tabledataurl: dataurl_1["default"] };
var orgCode = utils_1["default"].getUrlParams('orgcode');
var orgName = utils_1["default"].getUrlParams('orgname') ? utils_1["default"].getUrlParams('orgname') : '单个作者';
var authorId = utils_1["default"].getUrlParams('authorid') ? utils_1["default"].getUrlParams('authorid') : '';
var authorName = utils_1["default"].getUrlParams('authorname') ? utils_1["default"].getUrlParams('authorname') : '';
var authorstr = authorId + '.' + authorName;
// $(".organthor").text(orgName + '-' + authorName + '发布研报')
//设置默认时间 
$('#beginDate').val(utils_1["default"].getDateStr(-2, 0, 0));
$('#endDate').val(utils_1["default"].getDateStr(0, 0, 0));
var _datatable = new datatable_1["default"]({
    initdata: true,
    table_type: 'personalpublish',
    div_id: 'personalpublish_table',
    pager_id: 'personalpublish_table_pager',
    loadingImg: true,
    initParams: {
        // author: authorstr.length>10 ? authorstr:'*',//作者 例：11000175403.潘红敏
        author: authorId,
        orgCode: orgCode,
        beginTime: utils_1["default"].getDateStr(-2, 0, 0),
        endTime: utils_1["default"].getDateStr(0, 0, 0)
    }
});
$("#change_time").change(function () {
    var id = $(this).children('option:selected').val();
    var searchobj = {
        pageNo: 1
    };
    switch (id) {
        case "1":
            searchobj.beginTime = utils_1["default"].getDateStr(0, 0, -7);
            searchobj.endTime = utils_1["default"].getDateStr(0, 0, 0);
            break;
        case "2":
            searchobj.beginTime = utils_1["default"].getDateStr(0, -1, 0);
            searchobj.endTime = utils_1["default"].getDateStr(0, 0, 0);
            break;
        case "3":
            searchobj.beginTime = utils_1["default"].getDateStr(0, -6, 0);
            searchobj.endTime = utils_1["default"].getDateStr(0, 0, 0);
            break;
        case "4":
            searchobj.beginTime = utils_1["default"].getDateStr(-1, 0, 0);
            searchobj.endTime = utils_1["default"].getDateStr(0, 0, 0);
            break;
        case "5":
            searchobj.beginTime = utils_1["default"].getDateStr(-2, 0, 0);
            searchobj.endTime = utils_1["default"].getDateStr(0, 0, 0);
            break;
    }
    ;
    _datatable.search(searchobj);
});
//2策略报告，3宏观研究，4券商晨会 :单个作者跳转
// let author = authorstr.length> 10 ? authorstr : '*';
$(".tab_stock").attr('href', 'stock.jshtml?orgcode=' + orgCode + '&authorstr=' + authorId);
$(".tab_industry").attr('href', 'industry.jshtml?orgcode=' + orgCode + '&authorstr=' + authorId);
$(".tab_strategy").attr('href', 'strategyreport.jshtml?orgcode=' + orgCode + '&authorstr=' + authorId);
$(".tab_broker").attr('href', 'brokerreport.jshtml?orgcode=' + orgCode + '&authorstr=' + authorId);
$(".tab_macresearch").attr('href', 'macresearch.jshtml?orgcode=' + orgCode + '&authorstr=' + authorId);
